import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  status: {
    float: 'left',
  },
});

export default useStyles;
